import { render, staticRenderFns } from "./kind.vue?vue&type=template&id=1e772dcd"
import script from "./kind.vue?vue&type=script&lang=js"
export * from "./kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports